import React from 'react';
import { Avatar, Box, Chip, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';

export const receiptStatusLabel = status => ({
  opened: 'Interacted', delivered: 'Viewed', sent: 'Delivered',
  pending: 'Send pending', failed: 'Send rejected', unknown: 'Send outcome unknown',
  not_registered: 'Not delivered', disabled: 'Notifications disabled',
  suppressed: 'Excluded by app policy', historical: 'Historical', untracked: 'Not recorded',
}[status] || 'Unknown');
export const formatNotificationDate = value => value && !Number.isNaN(new Date(value).getTime())
  ? new Date(value).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : 'Not recorded';
const permissionLabel = value => ({ granted: 'Enabled', provisional: 'Quiet notifications', denied: 'Disabled', suppressed: 'Excluded by app policy' }[value] || 'Unknown');

export default function NotificationAudience({ recipients, historical, threshold }) {
  return <TableContainer>
    <Table aria-label="Notification audience" sx={{ minWidth: 880 }}>
      <TableHead><TableRow sx={{ backgroundColor: '#F8FAFC' }}>
        {['User', 'Status', 'Viewed', 'Interacted', 'Last app activity', 'Push permission'].map(label => <TableCell key={label}>{label}</TableCell>)}
      </TableRow></TableHead>
      <TableBody>
        {recipients.map(user => <TableRow key={user.client_id} hover>
          <TableCell sx={{ minWidth: 230, maxWidth: 360 }}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Avatar sx={{ width: 36, height: 36, bgcolor: '#EEF2FF', color: '#4338CA', fontSize: 14 }}>{(user.name || '?').charAt(0).toUpperCase()}</Avatar>
              <Box sx={{ minWidth: 0 }}><Typography variant="body2" fontWeight={600}>{user.name}</Typography>
                <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>{user.email || 'No email recorded'}</Typography>
              </Box>
            </Stack>
            {user.warning && <Typography variant="caption" display="block" sx={{ mt: 1, color: '#92400E', bgcolor: '#FFFBEB', borderRadius: 1, p: 1 }}>
              No delivery confirmation for the last {threshold} eligible notifications.
            </Typography>}
          </TableCell>
          <TableCell><Chip size="small" variant="outlined" label={receiptStatusLabel(user.status)}
            color={user.status === 'opened' ? 'success' : user.status === 'delivered' ? 'primary' : user.status === 'failed' ? 'error' : 'default'} /></TableCell>
          <TableCell>{historical ? 'Unavailable' : formatNotificationDate(user.delivered_at)}</TableCell>
          <TableCell>{historical ? 'Unavailable' : formatNotificationDate(user.opened_at)}</TableCell>
          <TableCell>{formatNotificationDate(user.last_app_activity)}</TableCell>
          <TableCell><Tooltip title={`Last reported: ${formatNotificationDate(user.permission_checked_at)}`}><span>{permissionLabel(user.notification_permission)}</span></Tooltip></TableCell>
        </TableRow>)}
        {!recipients.length && <TableRow><TableCell colSpan={6} align="center" sx={{ py: 7 }}>
          <Typography fontWeight={600}>No users in this view</Typography>
          <Typography variant="body2" color="text.secondary">Try another tab or change your search.</Typography>
        </TableCell></TableRow>}
      </TableBody>
    </Table>
  </TableContainer>;
}
